import { render, staticRenderFns } from "./HealthQuestionnaire2.vue?vue&type=template&id=cfd22b4c"
import script from "./HealthQuestionnaire2.vue?vue&type=script&lang=js"
export * from "./HealthQuestionnaire2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports